import React from 'react';

import { useDownloadCompeonFile } from 'components/DownloadBlock/useDownloadCompeonFile';
import { CompeonDocument } from 'models/InquiryDetails/DefaultInquiryDetails.model';
import { ButtonComponent } from 'theme/components/Button';
import DownloadIcon from 'theme/components/Icon/DownloadIcon';
import { useTranslations } from 'utils/hooks/useTranslations';

interface IDownloadCompeonFile {
  file: CompeonDocument;
}

const DownloadCompeonFile = ({ file }: IDownloadCompeonFile) => {
  const t = useTranslations('components.upload');
  const downloadFile = useDownloadCompeonFile({ fileId: file.id, fileName: file.fileName });

  return (
    <ButtonComponent
      data-testid="download-file-btn"
      leftIcon={<DownloadIcon boxSize={6} display="block" />}
      onClick={downloadFile}
    >
      {t('download')}
    </ButtonComponent>
  );
};

export default DownloadCompeonFile;
